<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="650")
  yz-card
    yz-dialog-normal-header(title="Base unit change detected" @close="onClose")
    yz-dialog-normal-content.pa-6
      .d-flex.align-start
        yz-icon.mr-2(color="danger" size="20") mdi-alert-circle
        .yz-medium-body-sm.text-neutral-700 This will replace the current base unit and automatically recalculate stock quantities and UOM conversions.
      .yz-regular-body-sm.text-neutral-500.mt-4 Pending items using previous units will require updates. Review carefully before proceeding.
      v-row.mt-6(no-gutters align="center")
        v-col
          .yz-medium-body-xs.text-neutral-700.mb-2 Current base unit
          yz-text-field(value="1" size="lg" disabled background-color="neutral-300" :suffix="originalUom")
          .yz-regular-body-xs.text-neutral-500.mt-1 Current stock on hand: {{ currentStockOnHand }}
        v-col.d-flex.justify-center(cols="auto" style="padding: 28px 16px 0;")
          v-icon(size="20") mdi-equal
        v-col
          .yz-medium-body-xs.text-neutral-700.mb-2 New base unit
          yz-text-field(v-model="baseMultiplier" placeholder="0" type="number" size="lg" :suffix="newUom" :rules="rules.positive")
          .yz-regular-body-xs.mt-1(:class="newStockOnHand > 0 ? 'text-neutral-500' : 'text-danger-500'") New stock on hand: {{ newStockOnHand }}
    yz-dialog-normal-actions(cancel-label="Back" save-label="Change base unit" :loading="isSaving" @cancel="onClose" @save="onConfirmBaseChange")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    originalUom: {
      type: String,
      default: null
    },
    newUom: {
      type: String,
      default: null
    },
    currentStockOnHand: {
      type: Number,
      default: 0
    },
    companySlug: {
      type: String,
      default: null
    },
    medicationId: {
      type: [Number, String],
      default: null
    },
    uomConversions: {
      type: Array,
      default: () => []
    },
    apiEndpoint: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      baseMultiplier: null,
      isSaving: false,
      rules: {
        positive: [v => (v !== null && v !== '' && Number(v) > 0) || 'Value must be greater than 0']
      }
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    newStockOnHand() {
      if (!this.baseMultiplier || Number(this.baseMultiplier) <= 0) return 0
      return Math.floor(this.currentStockOnHand * Number(this.baseMultiplier))
    }
  },
  watch: {
    value(val) {
      if (val) this.baseMultiplier = null
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onClose() {
      this.showDialog = false
    },
    async onConfirmBaseChange() {
      this.isSaving = true
      try {
        const url = this.apiEndpoint || `/clinics/${this.companySlug}/hq/medications/${this.medicationId}`
        await this.$axios.patch(url, {
          product: {
            uom: this.newUom,
            uom_conversion_enabled: true,
            uom_conversions: this.uomConversions,
            base_uom_conversion: {
              uom: this.originalUom,
              convert_to: this.newUom,
              multiplier: Number(this.baseMultiplier)
            }
          }
        })
        this.showMessage(['success', 'Base unit changed successfully'])
        this.$emit('saved')
        this.showDialog = false
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isSaving = false
      }
    }
  }
}
</script>
